import { reimAbsolute, reimPhaseCorrection, reimAutoPhaseCorrection, } from 'ml-spectra-processing';
export const id = 'phaseCorrection';
export const name = 'Phase correction';
export function apply(datum1D, options) {
    if (!isApplicable(datum1D)) {
        throw new Error('phaseCorrection not applicable on this data');
    }
    const { absolute = false } = options;
    const filter = datum1D.filters?.find((filter) => filter.name === id);
    if (absolute) {
        datum1D.data.re = reimAbsolute(datum1D.data);
        datum1D.data.im = new Float64Array(0);
        if (filter) {
            filter.value = { ...filter.value, ph0: 0, ph1: 0, absolute };
        }
    }
    else if ('ph0' in options && 'ph1' in options) {
        let { ph0, ph1 } = options;
        phaseCorrection(datum1D, { ph0, ph1 });
        if (filter) {
            filter.value = { ...filter.value, absolute };
        }
    }
    else {
        let { ph0, ph1 } = autoPhaseCorrection(datum1D);
        phaseCorrection(datum1D, { ph0, ph1 });
        if (filter) {
            filter.value = { ...filter.value, absolute, ph0, ph1 };
        }
    }
}
export function isApplicable(datum1D) {
    if (datum1D.info.isComplex && !datum1D.info.isFid)
        return true;
    return false;
}
export function reduce(previousValue, newValue) {
    return {
        once: true,
        reduce: newValue,
    };
}
function phaseCorrection(datum1D, { ph0, ph1 }) {
    ph0 *= Math.PI / 180;
    ph1 *= Math.PI / 180;
    datum1D.data = {
        ...datum1D.data,
        ...reimPhaseCorrection(datum1D.data, ph0, ph1),
    };
}
function autoPhaseCorrection(datum1D, options = {}) {
    const { minRegSize = 5, maxDistanceToJoin = 128, magnitudeMode = true, factorNoise = 5, } = options;
    return reimAutoPhaseCorrection(datum1D.data, {
        minRegSize,
        maxDistanceToJoin,
        magnitudeMode,
        factorNoise,
    });
}
